module.exports = __webpack_public_path__ + "img/ecommerce.757dba6d.png";